import { Product } from '@shared/models/product';

const SUGGESTION_LIMIT = 30;

/**
 * Catalogue suggestions for the inline service entry. Enter takes the first entry, so exact matches
 * come first – a scanned article number must not lose to a longer one that merely contains it (#7265).
 * Order: exact article number, exact name, article-number prefix, then the rest in catalogue order.
 */
export function filterBookingV2ProductSuggestions(
    products: Product[],
    itemNumberQuery: string,
    titleQuery: string,
): Product[] {
    const item = itemNumberQuery.trim().toLowerCase();
    const title = titleQuery.trim().toLowerCase();
    const needle = title || item;

    if (needle.length < 1) {
        return [];
    }

    const rank = (name: string, num: string): number => {
        if (item && num === item) {
            return 0;
        }
        if (name === needle) {
            return 1;
        }
        if (item && num.startsWith(item)) {
            return 2;
        }
        return 3;
    };

    return products
        .map((product, index) => ({
            product,
            index,
            name: product.name.toLowerCase(),
            num: (product.itemNumber || '').toLowerCase(),
        }))
        .filter(entry => entry.name.includes(needle) || (!!item && entry.num.includes(item)))
        .map(entry => ({ ...entry, rank: rank(entry.name, entry.num) }))
        .sort((a, b) => a.rank - b.rank || a.index - b.index)
        .slice(0, SUGGESTION_LIMIT)
        .map(entry => entry.product);
}
